import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  emptyFullIntakeForm,
  INTAKE_MODES,
  INTAKE_SOURCES,
} from '../utils/permitIntake';
import { usePermitIntake } from '../hooks/usePermitIntake';
import PageShell from './PageShell';

const PermitForm = () => {
  const [formData, setFormData] = useState(emptyFullIntakeForm);
  const navigate = useNavigate();

  const { submit, submitting, error, success } = usePermitIntake({
    source: INTAKE_SOURCES.FULL_FORM,
    mode: INTAKE_MODES.FULL,
    onSuccess: () => {
      setFormData(emptyFullIntakeForm());
      setTimeout(() => navigate('/map'), 1500);
    },
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submit(formData);
    } catch (_) {
      /* error in hook */
    }
  };

  return (
    <PageShell
      title="Fire alarm user permit"
      subtitle="Submit a permit with coordinates — it syncs to GovOps and the permit map."
    >
      <p className="rhs-muted">
        <Link to="/permit/submit">Address autocomplete submit</Link>
        {' · '}
        <Link to="/dashboard">Dashboard quick submit</Link>
        {' · '}
        <Link to="/map">View permit map</Link>
      </p>

      <form onSubmit={handleSubmit} className="rhs-card rhs-form-block max-w-xl">
        {error && <div className="rhs-error" role="alert">{error}</div>}
        {success && <div className="rhs-ok-text" role="status">{success}</div>}

        <input name="applicantName" placeholder="Applicant Name" value={formData.applicantName} onChange={handleChange} required />
        <input name="phoneNumber" placeholder="Phone Number" value={formData.phoneNumber} onChange={handleChange} required />

        <h4 className="rhs-card-title">Alarm location</h4>
        <input name="street" placeholder="Street address" value={formData.street} onChange={handleChange} required />
        <input name="unit" placeholder="Unit/Apt" value={formData.unit} onChange={handleChange} />
        <input name="city" placeholder="City" value={formData.city} onChange={handleChange} required />
        <input name="zipCode" placeholder="Zip code" value={formData.zipCode} onChange={handleChange} required />

        <input name="latitude" placeholder="Latitude" value={formData.latitude} onChange={handleChange} required />
        <input name="longitude" placeholder="Longitude" value={formData.longitude} onChange={handleChange} required />

        <h4 className="rhs-card-title">Contact info</h4>
        <input name="contactName" placeholder="Contact name" value={formData.contactName} onChange={handleChange} required />
        <input name="alternateNumber" placeholder="Alternate number" value={formData.alternateNumber} onChange={handleChange} />
        <input name="email" type="email" placeholder="Email" value={formData.email} onChange={handleChange} required />

        <h4 className="rhs-card-title">Billing address</h4>
        <input name="billingName" placeholder="Billing name" value={formData.billingName} onChange={handleChange} required />
        <input name="billingStreet" placeholder="Billing street" value={formData.billingStreet} onChange={handleChange} required />
        <input name="billingUnit" placeholder="Billing unit" value={formData.billingUnit} onChange={handleChange} />
        <input name="billingCity" placeholder="City" value={formData.billingCity} onChange={handleChange} required />
        <input name="billingState" placeholder="State" value={formData.billingState} onChange={handleChange} required />
        <input name="billingZip" placeholder="Zip code" value={formData.billingZip} onChange={handleChange} required />

        <h4 className="rhs-card-title">Alarm company</h4>
        <input name="alarmCompany" placeholder="Company name" value={formData.alarmCompany} onChange={handleChange} />
        <input name="alarmPhone" placeholder="Company phone" value={formData.alarmPhone} onChange={handleChange} />

        <label className="rhs-label">Property type</label>
        <select name="propertyType" value={formData.propertyType} onChange={handleChange}>
          <option value="Residential">Residential</option>
          <option value="Commercial">Commercial</option>
        </select>

        <input name="checkNumber" placeholder="Check number" value={formData.checkNumber} onChange={handleChange} />

        <button type="submit" className="rhs-btn" disabled={submitting}>
          {submitting ? 'Submitting…' : 'Submit permit'}
        </button>
      </form>
    </PageShell>
  );
};

export default PermitForm;
